import { render, staticRenderFns } from "./InviraRolesList.vue?vue&type=template&id=4c56fd56&scoped=true"
import script from "./InviraRolesList.vue?vue&type=script&lang=js"
export * from "./InviraRolesList.vue?vue&type=script&lang=js"
import style0 from "./InviraRolesList.vue?vue&type=style&index=0&id=4c56fd56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c56fd56",
  null
  
)

export default component.exports